import React, { useMemo, useState } from "react";
import {
  HomeFeaturedTestimonial,
} from "../../home/home-featured-testimonials";
import OrganicPortalSlider from "./organic-portal-slider";

type Props = {
  items?: HomeFeaturedTestimonial[];
  onVideoOpen: (src: string) => void;
  aspectRatio?: number;
};
const DEFAULT_TESTIMONIALS: HomeFeaturedTestimonial[] = [
  {
    id: "corgi",
    title: "Middleware reduced the time spent debugging and resolving issues by nearly 90%.",
    body:
      "What sets their AI apart is that it does not stop at detecting issues. It actually helps fix problems in production, and for engineering teams, that's been a real game changer. At Corgi, we rely on Middleware to monitor our entire infrastructure and application stack.",
    author: "Nico Laqua, CEO at Corgi",
    imageSrc: "/images/corgi-testimonial-1.webp",
    imageAlt: "Nico Laqua, CEO at Corgi",
    videoSrc: "/images/corgi-testimonial-demo.mp4",
  },
  {
    id: "eragon",
    title: "We chose Middleware because of their cutting edge AI capabilities.",
    body:
      "As companies continue to scale and deploy agents on eragon, it's critical that we get notified of any bugs or any issues within milliseconds. We use Middleware's AI capabilities and observability platform to do that, so we can continue to focus on our customers.",
    author: "Josh Sirota, CEO at Eragon",
    imageSrc: "/images/eragon-testimonial-1.webp",
    imageAlt: "Josh Sirota, CEO at Eragon",
    videoSrc: "/images/eragon-testimonial-mw.mp4",
  },
];
export default function ComparisonVideoTestimonial({
  items = DEFAULT_TESTIMONIALS,
  onVideoOpen,
  aspectRatio = 156 / 115,
}: Props) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = items[activeIndex] ?? items[0];
  const images = useMemo(
    () =>
      items.map((item) => ({
        id: item.id,
        src: item.imageSrc,
        alt: item.imageAlt,
      })),
    [items]
  );

  if (!active?.videoSrc) return null;

  return (
    <div className="customer-story-video">
      <div className="customer-story-video__frame">
        <button
          type="button"
          className="customer-story-video__play"
          onClick={() => onVideoOpen(active.videoSrc as string)}
          aria-label={`Play testimonial video: ${active.imageAlt}`}
        >
          <span
            className="customer-story-video__images"
            style={{ aspectRatio }}
          >
            <OrganicPortalSlider
              images={images}
              fit="contain"
              waitMs={4500}
              onActiveIndexChange={setActiveIndex}
            />
          </span>
        </button>
      </div>
      <style jsx>{`
        .customer-story-video__images {
          position: relative;
          display: block;
          width: 520px;
          max-width: 100%;
          overflow: hidden;
          background: transparent;
        }
      `}</style>
    </div>
  );
}
